// The six data columns every deliveries list renders, in the order they are read left to right.
// Shared because two lists now show them — the «Usuario» card's and the location tab's — and the
// column set is the contract between them: a header added or reordered in one and not the other
// would put labels over the wrong values on the screen that was not touched. Only the labels are
// shared; each list styles its own head (the location list uses `text.primary` for AA contrast).
// TODO: i18n — copy en ES hasta Fase 1.
export const DELIVERY_COLUMN_HEADERS = [
  'ENTREGA',
  'RECOGIDA',
  'ESTADO',
  'BUZÓN',
  'TRACKING',
  'CARRIER',
];
